import {PingAuthStatus} from './PingAuthStatus';
import PingAuthTokens, {emptyAuthTokens} from './PingAuthTokens';
import {emptyPingUser, PingUser} from './PingUser';

export default interface PingAuthContextProps {
    tokens: PingAuthTokens;
    logIn: () => void;
    logOut: () => void;
    user: PingUser;
    status: PingAuthStatus;
}

export const emptyPingAuthContext: PingAuthContextProps = {
    logIn: () => {},
    tokens: emptyAuthTokens,
    logOut: () => {},
    user: emptyPingUser,
    status: PingAuthStatus.NOT_INITIALIZED,
};
